import { render, staticRenderFns } from "./TaskSelectionTable.vue?vue&type=template&id=50bc1e29"
import script from "./TaskSelectionTable.vue?vue&type=script&lang=js"
export * from "./TaskSelectionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports